import styled from '@emotion/styled'
import { calcRem } from 'component-library/__styling/style-functions'
import { telethonRedColor } from './TelethonCountdown.styled'
import { themedValue } from 'component-library/__styling/themed-value'

export const StyledCountDown = styled('div')({
    display: 'flex',
})

export const StyledLabel = styled('span')({
    textAlign: 'center',
    display: 'block',
    fontSize: calcRem(13),
})

export const StyledItem = styled('span')(({ theme }) => ({
    fontSize: themedValue(theme, { fallback: calcRem(36), sevennews: calcRem(34) }),
    color: telethonRedColor,
    fontWeight: 700,
    whiteSpace: 'pre-wrap',
}))

export const StyledElement = styled('div')<{ separator?: boolean }>(({ separator, theme }) => ({
    textAlign: 'center',
    width:
        separator !== true
            ? themedValue(theme, { fallback: calcRem(52), sevennews: calcRem(45) })
            : undefined,
    display: 'inline-block',
    flexDirection: 'column',
}))
